import classNames from 'classnames'
import React from 'react'
import styles from './LogoHoC.module.scss'
import type { LogoHoCProps} from './types'
import { LogoSize, LogoSurface, LogoVariant } from './types'

const LogoHoC: React.FC<LogoHoCProps> = ({
  className,
  size = LogoSize.medium,
  surface = LogoSurface.onPrimary,
  variant = LogoVariant.logotype,
  brand,
  children,
}) => {
  return (
    <div
      className={classNames(styles['pintxo-logo'], className)}
      data-size={size}
      data-variant={variant}
      data-surface={surface}
      data-brand={brand}
    >
      {children && children}
    </div>
  )
}

export default LogoHoC
